const thumbnailOrigin =
  typeof window === "undefined"
    ? "https://kaidoki.natu.dev"
    : window.location.origin;

export const itemThumbnailUrl = (itemName: string) =>
  `${thumbnailOrigin}/item-thumbnails/v1/${itemName}.png`;

export const ITEM_THUMBNAIL_URLS = {
  bath: itemThumbnailUrl("bath"),
  kitchen: itemThumbnailUrl("kitchen"),
  laundry: itemThumbnailUrl("laundry"),
  cleaning: itemThumbnailUrl("cleaning"),
  medical: itemThumbnailUrl("medical"),
  baby: itemThumbnailUrl("baby"),
  stationery: itemThumbnailUrl("stationery"),
  other: itemThumbnailUrl("other"),
} as const;
